import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from '~/router';
import { getPaycodeById, updatePaycode } from '../../actions/paycodes';
import { SearchableModelHelper } from '~/lib/forms/select';
import { OrganizationType } from '~/apps/shared/consts';
import { createOrganizationHelper } from '~/apps/shared/services/forms';

import PaycodeFormOverlay from '../../components/codes/PaycodeFormOverlay';

import Loader from '~/common/components/Loader';


class EditPaycodePopup extends React.Component<any, any> {
  orgHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.orgHelper = createOrganizationHelper(this.refresh, this.getOrgById, null, OrganizationType.UNLOADER);
  }

  refresh = () => {
    this.forceUpdate();
  }

  getOrgById = (orgId: string) => {
    return this.props.organizations.entities[orgId];
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPaycodeById(this.props.paycodeId));
  }

  onSubmit = (data) => {
    const { dispatch, auth, paycodeId } = this.props;
    const orgId = auth.currentUser.organizationId;

    return dispatch(updatePaycode(paycodeId, data))
      .then(() => {
        navigate('sender.paycodes');
      });
  };

  onClose = () => {
    navigate('sender.paycodes');
  };

  render = () => {
    const { paycodes, paycodeId } = this.props;
    const paycode = paycodes.entities[paycodeId];
    const { loading, errorMessage } = paycodes.ui;

    if (!paycode || loading) {
      // TODO:
      return (
        <Loader className="load--ol"/>
      );
    }

    return (
      <PaycodeFormOverlay
        headTitle="Edit Payment"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        paycode={paycode}
        organizations={this.orgHelper}
        errorMessage={errorMessage}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.shared.auth,
    organizations: state.shared.organizations,
    paycodes: state.sender.paycodes,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPaycodePopup) as any;
